import React from "react";
import DiscountCard from "../cards/DiscountCard";

// Data \\
import data from "../../assets/data/discount.json";

// Style \\
import "../../assets/styles/sections/discount.scss";

import { Navigation, A11y } from "swiper/modules";

//  $$ Swipper $$ \\
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Discount = () => {
  return (
    <section className="discount py-40">
      <div className="discount_items">
        <div className="containers">
          <div className="discount_items_title text-center mb-16">
            <h3>Discounts</h3>
            <p className="text-xl w-2/4 mt-2 mx-auto">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
              facilis repellat error doloribus rerum eligendi.
            </p>
          </div>
          <Swiper
            className="swiper"
            modules={[Navigation, A11y]}
            spaceBetween={20}
            breakpoints={{
              992: {
                // spaceBetween: 40,
                slidesPerView: 3,
              },
              768: {
                // spaceBetween: 30,
                slidesPerView: 2,
              },
              576: {
                // spaceBetween: 20,
                slidesPerView: 1,
              },
            }}
            navigation
            pagination={{ clickable: true }}
            // scrollbar={{ draggable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log("slide change")}
          >
            {data.map((data, index) => (
              <SwiperSlide className="slideSwipper">
                <DiscountCard key={data.id} data={data} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Discount;
